import {
    getDataMapper,
    mapField,
    parseISO,
    mapHumanFromServer,
} from "@/shared";

import { mapAdditionalServiceFromServer } from "@/entities/additional-services/@x";
import { mapClientFromServer } from "@/entities/client/@x";
import { mapDiscountFromServer } from "@/entities/discounts/@x";
import { mapPointFromServer } from "@/entities/points/@x";
import { mapProductFromServer } from "@/entities/products/@x";

export const mapCalculatedSellingFromServer = getDataMapper({
    id: mapField("id", Number),
    sum: mapField("sum", Number),
    totalSum: mapField("sum_real", Number),
    discountSum: mapField("sum_discount", Number),
    paid: mapField("payed", Number),
    additionalServiceSum: mapField("sum_additional_service", Number),
    productSum: mapField("sum_product", Number),
    additionalPayment: mapField(null, () => 0, { applyToNil: true }),
    additionalPaymentType: mapField(null, () => 1, { applyToNil: true }),
    client: mapField("human", mapClientFromServer),
    clientId: mapField("human", (client) => client?.id),
    adminUser: mapField("admin_user", mapHumanFromServer),
    point: mapField("point", mapPointFromServer),
    comment: mapField("comment"),
    products: mapField("products", {
        product: mapField("product", mapProductFromServer),
        count: mapField("count", Number),
        max: mapField("max", Number),
    }),
    additionalServices: mapField("additional_services", {
        additionalService: mapField(
            "additional_service",
            mapAdditionalServiceFromServer
        ),
        count: mapField("count", Number),
    }),
    payments: mapField("payments", {
        id: mapField("id", Number),
        date: mapField("date", parseISO),
        value: mapField("value", Number),
        payType: mapField("pay_type", {
            title: mapField("title"),
            const: mapField("const"),
        }),
    }),
    discounts: mapField("discounts", {
        id: mapField("id", Number),
        discount: mapField("discount", mapDiscountFromServer),
        sum: mapField("sum", Number),
    }),
    check: mapField("check"),
    fDocDocuments: mapField("fdoc_documents", {
        id: mapField("id"),
        link: mapField("reference"),
        status: mapField("status"),
        title: mapField("name"),
    }),
});
